import { addSpaceIfNeeded } from "../addSpaceIfNeeded";

export const addAOPlatformToLayout = (
  newLayout,
  format,
  campaignId,
  provider,
) => {
  const lastEl = addSpaceIfNeeded("overlap-platform", newLayout, format);

  const x = 0;
  let y = 0;
  const w = 4;
  const h = 3;

  y = lastEl.y + lastEl.h;

  const i = `overlap-platform-${provider}-${campaignId}`;
  newLayout.push({ i, x, y, w, h });
};
